export default "__VITE_PUBLIC_ASSET__938d319e__"